<template>
  <main id="orders-single" class="site-main">
    <div class="single-detail">
      <div class="grid-container">
        <div class="single-detail__header">
          <div class="single-detail__header__detail">
            <div class="grid-x align-bottom">
              <div class="cell shrink">
                <h1 style="font-size: 30px; margin: 0 15px 0 0;">{{ order.name }}</h1>
              </div>

              <div class="cell shrink">
                <div style="margin-right: 30px; position: relative; top: 1px;">{{ date }}</div>
              </div>

              <div class="cell shrink">
                <div class="grid-x align-middle" style="position: relative; top: -4px;">
                  <div class="cell shrink">
                    <div :class="['label', this.financialLabel]" style="margin-right: 10px;">
                      {{ financialStatus }}
                    </div>
                  </div>

                  <div class="cell shrink">
                    <div :class="['label', this.fulfillmentLabel]" style="margin-right: 10px;">
                      {{ fulfillmentStatus }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="cell auto text-right">
                <div style="font-size: 24px; font-weight: 700;">{{ price }}</div>
              </div>
            </div>
          </div>

          <div class="single-detail__header__actions">
            <a :href="order.url" target="_blank"><i class="fas fa-eye"></i> View in Shopify</a>
          </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="cell large-auto">
            <div class="panel no-padding">
              <div :class="['loading-area', loading ? 'loading' : '']">
                <div :class="['loading-area__content', loading ? 'loading' : '']">
                  <div class="line-items">
                    <tableList classes="no-hover" :header="tableHeader" :data="tableData"
                               :loading="loading" @sort="orderBy" @callback="callback"></tableList>
                  </div>
                </div>
              </div>
            </div>

            <salesCommissions></salesCommissions>
          </div>

          <div class="cell large-shrink">
            <div class="sidebar">
              <div class="panel">
                <div class="form-field">
                  <label>Customer</label><br>
                  <div>{{ order.customer_name }}</div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Notes</label><br>
                  <div>{{ order.note }}</div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Shipping</label><br>
                  <div>{{ order.address1 }} {{ order.address2 }}<br>
                    {{ order.city }}, {{ order.province }} {{ order.zip }}
                  </div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Tags</label><br>
                  <div class="tags" v-html="order.tags"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import salesCommissions from '@/pages/orders/inc/salesCommissions'
import moment from 'moment'

export default {
  name: 'ordersSalesrepSingle',
  mixins: [client, paginationUtils],
  components: {
    salesCommissions
  },
  data: function () {
    return {
      editingLineItem: null,
      editingCommission: false,
      editingCommissionValue: '',
      editingVendor: false,
      searchingVendors: false,
      searchedVendors: [],
      order: {
        name: '#0000',
        url: '#'
      },
      date: 'Mon 1, 1970 at 0:00am',
      financialLabel: '',
      financialStatus: 'Payment',
      fulfillmentLabel: '',
      fulfillmentStatus: 'Fulfillment',
      price: 0,
      action: '/orders/' + this.$route.params.id + '/',
      sort: 'product__title',
      tableHeader: {
        data: [
          {
            label: 'Product',
            class: 'full'
          },
          {
            label: 'Fulfillment',
            class: 'medium'
          },
          {
            label: 'Price'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    editCommission (lineItem, value) {
      this.editingCommission = true
      this.editingLineItem = lineItem
      this.editingCommissionValue = value
    },
    closeCommission () {
      this.editingCommission = false
    },
    saveCommission () {
      this.loading = true

      let commission = document.getElementById('commission-override').value

      commission = commission.replace('$', '')
      commission = commission.replace('%', '')

      if (commission === '') {
        commission = null
      }

      this.editingCommission = false

      if (this.editingLineItem.override_commission_line_item.length > 0) {
        this.request('put', '/vendors/override-commission/' + this.editingLineItem.override_commission_line_item[0].id + '/update/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      } else {
        this.request('post', '/vendors/override-commission/create/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      }
    },
    editVendor (id, value) {
      this.editingVendor = true
    },
    closeVendor () {
      this.editingVendor = false
    },
    buildTable () {
      this.tableData = []
      this.order = this.data

      this.date = moment(this.data.processed_at).format('MMM D, YYYY [at] h:mma')
      this.price = this.formatMoney(this.data.total_price)

      this.order.url = 'https://' + this.$store.state.shop.myshopify_domain + '/admin/orders/' + this.order.id

      if (this.isEmpty(this.order.customer_name)) {
        this.order.customer_name = 'N/A'
      }

      if (this.isEmpty(this.order.note)) {
        this.order.note = 'N/A'
      }

      if (!this.isEmpty(this.order.tags)) {
        let tags = this.order.tags.split(',')
        this.order.tags = ''

        for (let i = 0; i < tags.length; i++) {
          this.order.tags += '<div class="label">' + tags[i].trim() + '</div>'
        }
      }

      this.financialStatus = this.data.financial_status
      this.fulfillmentStatus = this.data.fulfillment_status

      if (this.data.financial_status === 'pending' ||
        this.data.financial_status === 'partially_paid' ||
        this.data.financial_status === 'partially_refunded' ||
        this.data.financial_status === 'authorized') {
        this.financialLabel = 'warning'
      } else if (this.data.financial_status === 'voided' ||
        this.data.financial_status === 'refunded') {
        this.financialLabel = 'alert'
      } else {
        this.financialLabel = 'success'
      }

      if (this.data.fulfillment_status === 'partial') {
        this.fulfillmentLabel = 'warning'
        this.fulfillmentStatus = 'Partially Fulfilled'
      } else if (this.data.fulfillment_status === 'restocked' ||
        this.data.fulfillment_status === null) {
        this.fulfillmentLabel = 'alert'
      } else {
        this.fulfillmentLabel = 'success'
      }

      if (this.data.fulfillment_status === null) {
        this.fulfillmentStatus = 'Unfulfilled'
      }

      this.financialStatus = this.formatText(this.financialStatus)
      this.fulfillmentStatus = this.formatText(this.fulfillmentStatus)

      let lineItems = this.data.line_items

      for (let i = 0; i < lineItems.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(lineItems[i].image) && lineItems[i].image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItems[i].variant !== null && lineItems[i].variant.product !== null) {
          primary += '</div></div><div class="cell auto"><span class="text-overflow">' + lineItems[i].variant.product.title + '</span>'
        } else {
          primary += '</div></div><div class="cell auto">'
        }

        if (lineItems[i].title !== null && lineItems[i].title.length > 0 && lineItems[i].title !== 'Default Title') {
          primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].title + '</i></small></span>'
        }

        if (lineItems[i].sku !== null && lineItems[i].sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let lineItemFulfillmentStatus = 'success'

        if (lineItems[i].fulfillment_status === 'partial') {
          lineItemFulfillmentStatus = 'warning'
          lineItems[i].fulfillment_status = 'Partially Fulfilled'
        } else if (lineItems[i].fulfillment_status === 'restocked' ||
          lineItems[i].fulfillment_status === null) {
          lineItemFulfillmentStatus = 'alert'
        }

        if (lineItems[i].fulfillment_status === null || lineItems[i].fulfillment_status.length === 0) {
          lineItems[i].fulfillment_status = 'Unfulfilled'
          lineItemFulfillmentStatus = 'alert'
        }

        let price = '<div class="grid-x"><div class="cell shrink">' + this.formatMoney(lineItems[i].price)

        if (lineItems[i].allocated_discount > 0) {
          price += '<div class="text-right">-' + this.formatMoney(lineItems[i].allocated_discount) + '</div>'
        }

        price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItems[i].quantity + '</div></div>'

        let commission = this.formatMoney(lineItems[i].commission_amount)

        let commissionCol = {
          value: commission,
          span: 'focus-text',
          edit: true,
          callback: 'editCommission',
          callbackArgs: [lineItems[i], null]
        }

        if (lineItems[i].commission_type === 'override') {
          commission = '*' + commission

          commissionCol['value'] = commission
          commissionCol['callbackArgs'] = [lineItems[i], lineItems[i].commission_amount.toFixed(2)]
        }

        if (lineItems[i].vendor_paid) {
          commissionCol['value'] = '<strike>' + commission + '</strike>'
          commissionCol['edit'] = false
          commissionCol['callback'] = null
        }

        this.tableData.push({
          post: lineItems[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },
            {
              value: this.formatText(lineItems[i].fulfillment_status),
              class: 'medium',
              span: 'label ' + lineItemFulfillmentStatus
            },
            {
              value: price,
              span: 'fill'
            }
          ]
        })
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.line-items {
  padding: 15px 0;

  .table-list__body > .grid-x:last-child {
    border-bottom: 0;
  }
}

.tags {
  .label {
    margin: 0 5px 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/orders/salesrepSingle.vue